import { observer } from 'mobx-react-lite';

import { MaskedIcon } from '@/components/MaskedIcon/MaskedIcon';
import ErrorIcon from '@/images/CloseWithRedCircle.svg';
import { useCreateAvatarStore } from '@/pages/avatar/common/context';
import theme from '@/theme';
import styled from '@emotion/styled';

import { ErrorTitle } from '../Styled/Title';
import { ConsentVideo } from './ConsentVideo';

const Container = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 550px;
`;

const Subtitle = styled.span`
    color: ${({ theme }) => theme.colors.secondary.main};
    text-align: center;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    letter-spacing: 0.15px;
    white-space: pre;
`;

export const ConsentError = observer(() => {
    const createAvatarStore = useCreateAvatarStore();

    return (
        <Container>
            <ErrorTitle>
                <MaskedIcon src={ErrorIcon} size="32px" color={theme.colors.error.main} />
                We couldn't validate your consent
            </ErrorTitle>
            {createAvatarStore.consentValidationErrorMessage && <Subtitle>{createAvatarStore.consentValidationErrorMessage}</Subtitle>}
            {createAvatarStore.consentVideoProps && <ConsentVideo {...createAvatarStore.consentVideoProps} />}
        </Container>
    );
});
